let _this;
export default {
  name: "modify-password",
  data() {
    return {
      modifyPsdModal: false, /*修改密码弹框*/
      psdInfo: {}, /*用户密码修改*/
      psdVerify: {}, /*密码修改验证*/
      sameOldPsdFlag: false, /*新旧密码一致判断*/
      notSameNewPsdFlag: false, /*新密码确认一致判断*/
      loginAgainModal: false,/*重新登录弹框*/
      api : window.g.VERIFICATION_ROOT,
      isForceModify:false,/*强制修改状态*/
      psdErrorFlag: false,
      lockedErrorDescription: '',
      //展示自动生成的的新密码
      editPsdModal:false,
      editPsdInfo:{
        oldPassword:'',
        password:'',
        step:1,
      },
      editPsdTaskId:'',
      passwordLimit:false,
      newPassFlag: false,
      newPsdErrorText :'',
      publicEncrypt:'',
    }
  },
  mounted() {
    _this = this;
    _this.getPublicEncrypt();
    _this.judgePsdExpired();
    eventBus.$on('verifyUserPsd',(adminId) =>{
      _this.initData(adminId);
    });
    eventBus.$on('editOtherPsd',(adminId,taskId) =>{
      _this.editPsdInfo.id = adminId;
      _this.editPsdInfo.oldPassword = '';
      _this.editPsdInfo.step = 1;
      _this.editPsdModal = true;
      _this.psdErrorFlag = false;
      _this.passwordLimit = false;
      _this.lockedErrorDescription = '';
      _this.newPassFlag = false;
      _this.newPsdErrorText ='';
      _this.editPsdTaskId = taskId;
    });
  },
  beforeDestroy(){
    eventBus.$off('verifyUserPsd');
    eventBus.$off('editOtherPsd');
  },
  methods: {
    getPublicEncrypt:function(){
      this.$ajax.get('Encryption/GetRSAPublicKey').then(function (res) {
        if (res.data.success) {
          _this.publicEncrypt = res.data.data;
        } else {
          _this.publicEncrypt = '';
        }
      })
    },
    // 新旧密码判断是否一致
    judgeOldPsd: function () {
      _this.sameOldPsdFlag = false;
      let reg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g;
      if (reg.test(_this.psdInfo.password) || /\s/g.test(_this.psdInfo.password)){
        _this.passwordLimit = true;
      }else {
        _this.passwordLimit = false;
      }
      if ( _this.psdInfo.oldPassword && _this.psdInfo.password && _this.psdInfo.oldPassword === _this.psdInfo.password ){
        _this.sameOldPsdFlag = true;
      }
    },
    // 判断确认密码判断一致
    judgeNewPsd: function () {
      _this.notSameNewPsdFlag = false;
      _this.newPassFlag = false;
      if ( _this.psdInfo.password && _this.psdInfo.confirmPassword && _this.psdInfo.password !== _this.psdInfo.confirmPassword ){
        _this.notSameNewPsdFlag = true;
      }
    },
    // 信息提交
    savePsdInfo:function () {
      _this.judgeOldPsd();
      _this.judgeNewPsd();
      _this.$validator.validateAll('passwordInfo').then(result =>{
        if( result && !_this.sameOldPsdFlag && !_this.notSameNewPsdFlag && !_this.passwordLimit){
          let subData = JSON.parse(JSON.stringify(_this.psdInfo));

          let encrypt = new _this.jsEncrypt();
          encrypt.setPublicKey(_this.publicEncrypt);
          subData.password = encrypt.encrypt(subData.password);
          subData.oldPassword = encrypt.encrypt(subData.oldPassword);
          subData.confirmPassword = encrypt.encrypt(subData.confirmPassword);

          _this.$ajax.post('Account/ChangePassword',subData).then(function (res) {
            if(res.data.success){
              _this.messageNotice('success');
              _this.modifyPsdModal= false;
              if(_this.$root.adminInfo.id === _this.psdInfo.id){
                _this.loginAgainModal = true;
              }
            } else if(res.data.message.indexOf('The password that you have entered is incorrect') > -1){
              _this.psdErrorFlag = true;
              _this.lockedErrorDescription = res.data.message;
            } else if(res.data.message === 'Maximum attempt reached. Please contact your system administrator to unlock your account.') {
              _this.logOut();
            } else if(res.data.message.indexOf('The new password cannot be the same as the previous') > -1){
              _this.newPassFlag = true;
              _this.newPsdErrorText = res.data.message;
            } else {
              _this.messageNotice('error', res.data.message);
            }
          })
        }
      });
    },
    // 注销登录
    logOut:function () {
      if( _this.$root.Authorization ){
        let quitInfo = {
          token:_this.$root.Authorization.split(' ')[1],
          grant_type:'refresh_token',
          client_id:'ultimo',
          client_secret:'secret',
        };
        let formData = new FormData();
        for (let key in quitInfo) {
          formData.append(key, quitInfo[key]);
        }
        this.$ajax.post('/connect/revocation',formData,
        {
          baseURL: window.g.LOGIN_ROOT
        }).then(function (res) {
          _this.$router.push({path:'/login'});
        });
      }else{
        _this.$router.push({path:'/login'});
      }
      this.loginAgainModal = false;
    },
    // 初始化信息
    initData:function (adminId) {
      _this.$validator.errors.clear('passwordInfo');
      _this.sameOldPsdFlag = false;
      _this.notSameNewPsdFlag = false;
      _this.passwordLimit = false;
      _this.psdInfo = {};
      _this.psdInfo.id = adminId;
      _this.psdVerify = {
        curPsdFlag:true,
        newPsdFlag:true,
        cofPsdFlag:true
      };
      _this.modifyPsdModal = true;
    },
    // 判断密码过期
    judgePsdExpired:function () {
      _this.isForceModify = false;
      const curTime = _this.moment().valueOf();
      const adminInfo = _this.$root.adminInfo;
      if(curTime > adminInfo.passwordExpirationTime && !_this.ApiService.isAdLogin && adminInfo.source != 'AD'){
        _this.initData(adminInfo.id);
        _this.isForceModify = true;
      }
    },
    /*********************************************重置他人密码 Start***********************************************/
    //确认修改密码
    saveOtherPsdInfo:function(){
      _this.$validator.validateAll('passwordInfo').then(result =>{
        if(result){
          _this.editPsdInfo.password = _this.common.generateRandomPassword();
          let subData = JSON.parse(JSON.stringify(_this.editPsdInfo));
          let encrypt = new _this.jsEncrypt();
          encrypt.setPublicKey(_this.publicEncrypt);
          subData.password = encrypt.encrypt(subData.password);
          subData.oldPassword = encrypt.encrypt(subData.oldPassword);
          subData.confirmPassword = subData.password;
          //提交密码
          _this.$ajax.post('Account/ChangePassword',subData).then(function (res) {
            if (res.data.success) {
              _this.editPsdInfo.step = 2;
            } else if(res.data.message.indexOf('The password that you have entered is incorrect') > -1) {
              _this.psdErrorFlag = true;
              _this.lockedErrorDescription = res.data.message;
            } else if(res.data.message === 'Maximum attempt reached. Please contact your system administrator to unlock your account.') {
              _this.logOut();
            } else if(res.data.message.indexOf('The new password cannot be the same as the previous') > -1){
              _this.newPassFlag = true;
              _this.newPsdErrorText = res.data.message;
            } else {
              _this.messageNotice('error', res.data.message);
            }
          })
        }
      });
    },
    //复制密码
    copePsd:function(str){
      let dom = $('.utm-copy-text')[0];
      dom.value = str;
      dom.select();
      document.execCommand("Copy");
      _this.messageNotice('success','Copy Successfully');
    },
    /*********************************************重置他人密码 End***********************************************/
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/modifyPassword.js